/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)
 
 Coded by www.creative-tim.com
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// Material Dashboard 2 React Base Styles
import colors from 'assets/theme/base/colors';

const { dark } = colors;

const globals = {
  html: {
    scrollBehavior: 'smooth'
  },
  '*, *::before, *::after': {
    margin: 0,
    padding: 0
  },
  'a, a:link, a:visited': {
    textDecoration: 'none'
  },
  'a.link:visited, .link:visited': {
    color: `${dark.main}`,
    transition: 'text-decoration 0.3s ease-in-out, color 0.3s ease-in-out !important'
  }
};

export default globals;
